Ext.define('SA.data.LocationValueFormats', {
    singleton: true,

    tuples: [
        ['usa:region', 'single-digit Census codes', /^[1-9]$/],
        ['usa:division', 'single-digit Census codes', /^[1-9]$/],
        ['usa:state', 'two-digit FIPS codes', /^\d{1,2}$/],
        ['usa:cbsa', 'five-digit FIPS codes', /^\d{5}$/],
        ['usa:congressionalDistrict', 'four-digit FIPS codes', /^\d{3,4}$/],
        ['usa:puma', 'codes consisting of a State FIPS code followed by a five-digit Census code', /^\d{6,7}$/],
        ['usa:county', 'five-digit FIPS codes', /^\d{4,5}$/],
        ['usa:stateUpperDistrict', 'codes consisting of a State FIPS code followed by a three-character Census code', /^\d{1,2}[0-9a-z-]{3}$/],
        ['usa:stateLowerDistrict', 'codes consisting of a State FIPS code followed by a three-character Census code', /^\d{1,2}[0-9a-z-]{3}$/],
        ['usa:secondarySchoolDistrict', 'codes consisting of a State FIPS code followed by a five-digit Department of Education code', /^\d{6,7}$/],
        ['usa:elementarySchoolDistrict', 'codes consisting of a State FIPS code followed by a five-digit Department of Education code',/^\d{6,7}$/],
        ['usa:place', 'seven-digit FIPS codes', /^\d{6,7}$/],
        ['usa:zipCode', 'five-digit Zip codes', /^\d{4,5}$/],
        ['usa:censusTract', '11-digit FIPS codes', /^\d{10,11}$/],
        ['usa:censusBlockGroup', '12-digit FIPS codes', /^\d{11,12}$/],
        ['usa:dma', 'two-letter DMA codes', /^[a-z]{2}$/i],
        ['can:province', 'two-digit SGC codes', /^\d{2}$/],
        ['can:cmaca', 'three-digit SGC codes', /^\d{1,3}$/],
        ['can:cd', 'four-digit SGC codes', /^\d{4}$/],
        ['can:csd', 'seven-digit SGC codes', /^\d{7}$/],
        ['can:ct', 'SGC codes consisting of seven digits, a period, and two digits', /^\d{5,7}(?:\.\d{0,2})?$/],
        ['can:da', 'eight-digit SGC codes', /^\d{8}$/],
        ['can:fsa', 'codes consisting of a letter, a digit, and a letter', /^[A-Z]\d[A-Z]$/i]
    ],

    getDescriptionForUnit(unit) {
        return this.getTupleForUnit(unit)[1];
    },

    getRegexForUnit(unit) {
        return this.getTupleForUnit(unit)[2];
    },

    getTupleForUnit(unit) {
        return this.tuples.find(tuple => tuple[0] === unit);
    }
});